<script>
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'

export default {
  name: 'FundraiserTeamListGroupItem' ,
  components: { TwTransitionContainer, TwButton, TwListGroupItem },
  props: {
    team: {
      type: Object,
      required: true
    },
    alwaysExpanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Expanded: false,
    }
  },
  methods: {
    toggleExpanded() {
      if(this.alwaysExpanded) return
      this.Expanded = !this.Expanded
    }
  }
}
</script>

<template>
  <div>
    <div class="flex gap-5 justify-between" @click="toggleExpanded">
      <div :class="[{'cursor-pointer': !alwaysExpanded},' flex items-center gap-3']">
        <icon v-if="!alwaysExpanded" :icon="Expanded? 'minus':'plus'" /> <h6 class="hover:underline">
          {{ team.name }}
        </h6>
      </div>
      <h6>
        Total Raised {{ team.cached.raised_formatted }}
      </h6>
    </div>
    <tw-transition-container>
      <div v-if="Expanded || alwaysExpanded" class="my-4">
        <div v-if="team.cached && team.cached.members && team.cached.members.length > 0" class="flex flex-col gap-2">
          <div v-for="member in team.cached.members" :key="'team-member-' + team.id + '-' + member.id" class="flex justify-between gap-4 text-sm md:text-base">
            <div>
              {{ member.name }}
            </div>
            <div class="text-right">
              {{ member.raised_formatted }}
            </div>
          </div>
        </div>
        <div v-else>
          No donations yet.
        </div>
      </div>
    </tw-transition-container>
  </div>
</template>

<style scoped>

</style>
